module.exports = __webpack_public_path__ + "img/invite_banner.c23a3f6b.png";